import { type ComponentType, useEffect, useState } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
export const withHideOnVisualEditor = <P extends {}>(
  WrappedComponent: ComponentType<P>
): React.FC<P> => {
  const WithStoryblok: React.FC<React.PropsWithChildren<P>> = (
    props: P
  ): JSX.Element | null => {
    const [isStoryBlok, setIsStoryBlok] = useState(false)
    useEffect(() => {
      // Check if the page is in an iFrame
      if (window.location !== window.parent.location) {
        // The page is in an iFrames
        setIsStoryBlok(true)
      }
    }, [])

    if (isStoryBlok) {
      return null
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent {...props} />
  }

  WithStoryblok.displayName = 'WithStoryblok'

  return WithStoryblok
}
